import React from 'react';
import { useDispatch } from 'react-redux';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { openModal } from '~/cards/actions/modalActions';
import { CheckboxField } from '@zola/zola-ui/src/components/Form/CheckboxField';

interface CustomFoilMenuProps {
  activeValue: boolean;
  updateFilter: (filter: 'has_foil', value: boolean) => void;
}

export const CustomFoilMenu: React.FC<CustomFoilMenuProps> = ({ activeValue, updateFilter }) => {
  const dispatch = useDispatch();

  return (
    <CheckboxField
      label={
        <div>
          {'Only show designs with foil. '}
          <LinkV2
            inline
            role="button"
            onClick={() =>
              dispatch(openModal('FILTER_FOIL_MODAL', {}, { bottomModalOnMobile: true }))
            }
          >
            What&apos;s foil?
          </LinkV2>
        </div>
      }
      id="custom-foil-menu"
      checked={activeValue}
      onChange={() => updateFilter('has_foil', !activeValue)}
      meta={{ touched: true }}
    />
  );
};
